import { useEffect, useState } from 'react'
import ReactSlider from 'react-slider'
import styled from 'styled-components'
export const Slider = ({
  questiondata,
  onChange,
  currentValue,
  title,
  inverted = false,
  questionNumber = 0,
}: {
  questiondata: Question
  onChange: (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => void
  currentValue: string | number | undefined
  title?: string
  inverted?: boolean
  questionNumber?: number
}) => {
  const { id, min = 0, max = 1, step, labels, unit, initial } = questiondata
  const [value, setValue] = useState(-1)
  const [hasBeenChanged, setHasBeenChanged] = useState(false)

  useEffect(() => {
    if (currentValue || currentValue === 0) {
      setValue(+currentValue)
      setHasBeenChanged(true)
    }
  }, [currentValue])

  return (
    <Container
      style={{
        paddingBottom: '10px',
      }}
    >
      {<Title>{title}</Title>}
      <StyledSlider
        min={min}
        max={max}
        step={step}
        value={currentValue || currentValue === 0 ? +currentValue : initial}
        className='horizontal-slider'
        thumbClassName='example-thumb'
        renderTrack={(props: any, state: any) => (
          <StyledTrack {...props} $index={state.index} $inverted={inverted} />
        )}
        renderThumb={(props: any, state: any) => {
          return (
            <StyledThumb
              $changed={hasBeenChanged}
              $showLeft={state.valueNow > min + (max - min) / 2}
              onClick={(e) => {
                if (!hasBeenChanged) {
                  setHasBeenChanged(true)
                  setValue(Math.round(min + (max - min) / 2))
                  onChange(
                    id,
                    Math.round(min + (max - min) / 2),
                    questionNumber
                  )
                }
              }}
              {...props}
            >
              <div>
                {hasBeenChanged ? (
                  <>{state.valueNow + ' ' + (unit ? unit : '') + ''}</>
                ) : (
                  <></>
                )}
              </div>
            </StyledThumb>
          )
        }}
        onChange={(value) => {
          setHasBeenChanged(true)
          setValue(value as number)
          onChange(id, value as number, questionNumber)
        }}
      />
      <LabelMin>{labels?.min}</LabelMin>
      <LabelMax>{labels?.max}</LabelMax>
    </Container>
  )
}

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 15px;
  line-height: 1em;
`
const Container = styled.div`
  position: relative;
  margin-bottom: 60px;
`
const Label = styled.div`
  position: absolute;
  bottom: -22px;
  color: var(--slider-labels);
  font-size: 14px;
  @media screen and (max-width: 717px) {
    font-size: 12px;
  }
`
const LabelMin = styled(Label)`
  left: 4px;
`
const LabelMax = styled(Label)`
  right: 4px;
`
const StyledSlider = styled(ReactSlider)`
  width: 100%;
  height: 25px;
  /* padding-top: 22px; */
`

const StyledThumb = styled.div<{ $changed: boolean; $showLeft: boolean }>`
  height: 25px;
  line-height: 40px;

  width: 25px;
  text-align: center;
  background-color: ${(props) => (props.$changed ? '#fff' : '#fff')};

  border: ${(props) =>
    props.$changed
      ? '4px solid var(--purple-main);'
      : '4px solid var(--beige-bright-1);'};

  color: #fff;
  border-radius: 100%;
  position: absolute;
  outline: none;

  cursor: grab;
  div {
    outline: none;
    width: 56px;
    white-space: nowrap;
    font-size: 15px;
    text-align: center;
    color: var(--purple-main);
    display: inline-block;
    position: absolute;
    height: 26px;
    left: ${(props) =>
      props.$showLeft ? 'calc(-100% - 66px)' : 'calc(100% + 18px)'};
    display: flex;
    align-items: center;
    line-height: 1em;
    /* transform: translateX(50%); */
    font-weight: 700;
    background-color: ${(props) =>
      props.$changed ? 'var(--purple-main)' : 'transparent'};
    color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    &:before {
      content: '';
      position: absolute;

      left: ${(props) => (props.$showLeft ? ' 88.5px' : '-12.5px')};
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;

      border-right: 13px solid
        ${(props) =>
          props.$changed && !props.$showLeft
            ? 'var(--purple-main)'
            : 'transparent'};
      border-left: 13px solid
        ${(props) =>
          props.$changed && props.$showLeft
            ? 'var(--purple-main)'
            : 'transparent'};
    }
  }
`

const StyledTrack = styled.div<{ $index: number; $inverted: boolean }>`
  /* top: 24px; */
  bottom: 5px;
  height: 6px;
  background: ${(props) =>
    props.$index === 2
      ? '#f00'
      : props.$inverted
      ? 'var(--input-unselected-bg-inverted)'
      : 'var( --input-unselected-bg)'};
  border-radius: 10px;
`

const Track = (props: any, state: any) => (
  <StyledTrack {...props} index={state.index} />
)
